import CheckCircle from "@mui/icons-material/CheckCircle";
import {
  Box,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
type Props = {
  calibrationItemCount: number;
  minimumItems: number;
  goalComplete: boolean;
  missingSamples: number;
};

export function CalibrationProgressCard({
  calibrationItemCount: sampleCount,
  minimumItems: minimumSamples,
  goalComplete,
  missingSamples,
}: Props) {
  const { t } = useTranslation();

  return (
    <Card variant="outlined" sx={{ mb: 4, bgcolor: "white" }}>
      <CardContent sx={{ p: 3, pb: "24px !important" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          mb={1.5}
        >
          <Box>
            <Typography
              variant="overline"
              color="text.secondary"
              fontWeight="bold"
            >
              {t("header.calibrate.samples")}
            </Typography>
            <Typography variant="h3" fontWeight="bold" lineHeight={1}>
              {sampleCount}
              <Typography component="span" variant="h5" color="text.secondary">
                {`/ ${minimumSamples}`}
              </Typography>
            </Typography>
          </Box>
          {goalComplete ? (
            <Chip
              icon={<CheckCircle />}
              label={t("text.calibrate.goal")}
              color="success"
              size="small"
              sx={{ fontWeight: "bold" }}
            />
          ) : (
            <Typography
              variant="body2"
              color="text.secondary"
              fontWeight="medium"
            >
              <span>
                {`${t("text.calibrate.missing_samples")}: ${missingSamples}`}
              </span>
            </Typography>
          )}
        </Stack>
        <LinearProgress
          variant="determinate"
          value={Math.min((sampleCount / 10) * 100, 100)}
          sx={{
            height: 10,
            borderRadius: 5,
            bgcolor: "var(--color-surface-muted)",
            "& .MuiLinearProgress-bar": { bgcolor: "primary.main" },
          }}
        />
      </CardContent>
    </Card>
  );
}
